import { render, staticRenderFns } from "./OrderServicePresetSelect.vue?vue&type=template&id=401e0a66&scoped=true"
import script from "./OrderServicePresetSelect.vue?vue&type=script&lang=js"
export * from "./OrderServicePresetSelect.vue?vue&type=script&lang=js"
import style0 from "./OrderServicePresetSelect.vue?vue&type=style&index=0&id=401e0a66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e0a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401e0a66')) {
      api.createRecord('401e0a66', component.options)
    } else {
      api.reload('401e0a66', component.options)
    }
    module.hot.accept("./OrderServicePresetSelect.vue?vue&type=template&id=401e0a66&scoped=true", function () {
      api.rerender('401e0a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/StandaloneOrders/OrderServicePresetSelect.vue"
export default component.exports